import { render, staticRenderFns } from "./eventProperty.vue?vue&type=template&id=367d0716&scoped=true"
import script from "./eventProperty.vue?vue&type=script&lang=js"
export * from "./eventProperty.vue?vue&type=script&lang=js"
import style0 from "./eventProperty.vue?vue&type=style&index=0&id=367d0716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d0716",
  null
  
)

export default component.exports